import { Component, inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DocumentFeedbackModel } from './document-feedback.model';
import { DocumentFeedbackService } from '../../services/document-feedback.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'pace-forms-document-feedback',
    templateUrl: './document-feedback.component.html',
    styleUrl: './document-feedback.component.scss',
    standalone: false,
})
export class DocumentFeedbackComponent implements OnInit {
    @Input() public model: DocumentFeedbackModel;
    public documentFeedbackForm: FormGroup;
    private formBuilder = inject(FormBuilder);
    private documentFeedbackService = inject(DocumentFeedbackService);
    public modalInstance = inject(BsModalRef);
    public formChildren: FormArray;

    public ngOnInit(): void {
        this.formChildren = this.formBuilder.array([]);
        this.documentFeedbackForm = this.formBuilder.group({
            children: this.formChildren,
        });
    }
    public submitData(): void {
        this.modalInstance.hide();
        this.documentFeedbackService.createSharpIncident(this.model).pipe(take(1)).subscribe();
    }
}
